import { Component, Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of, Subject } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { DiscardConfirmationDialogComponent } from '../../shared/components/discard-confirmation-dialog';

type CanDeactivateComponent = Component & {
  formDiscardAction?: Observable<boolean>;
  actionSubject?: Subject<boolean>;
  canDeactivate(): boolean | Observable<boolean>;
};

@Injectable({
  providedIn: 'root',
})
export class FormChangesCanDeactivateGuard {
  private dialog = inject(MatDialog);

  canDeactivate(
    component: CanDeactivateComponent
  ): Observable<boolean> | Promise<boolean> | boolean {
    return (
      component.canDeactivate() ||
      this.canDeactivateConfirmation(component.formDiscardAction, component.actionSubject)
    );
  }

  canDeactivateConfirmation(
    formDiscardAction: Observable<boolean>,
    actionSubject: Subject<boolean>
  ): Observable<boolean> {
    return this.dialog
      .open(DiscardConfirmationDialogComponent, { width: '360px' })
      .beforeClosed()
      .pipe(
        tap((discard: boolean) => {
          if (actionSubject) {
            actionSubject.next(discard);
          }
        }),
        switchMap((discard: boolean) =>
          discard && formDiscardAction ? formDiscardAction : of(discard)
        )
      );
  }
}
